export const initalData = {
  loader: true,
  setLoader: () => null,
};
